export default __webpack_public_path__ + "static/media/Imagem do sistema.1796c7d7.png";